import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { changeServerPassword } from "../../api";

const LEVELS = [
  { w: "0%", c: "var(--red)", t: "Quá yếu" },
  { w: "25%", c: "var(--red)", t: "Yếu" },
  { w: "50%", c: "var(--amber)", t: "Trung bình" },
  { w: "75%", c: "var(--blue)", t: "Tốt" },
  { w: "100%", c: "var(--green)", t: "Rất mạnh" },
];

function strength(pw) {
  let sc = 0;
  if (pw.length >= 8) sc++;
  if (pw.length >= 12) sc++;
  if (/[A-Z]/.test(pw)) sc++;
  if (/[0-9]/.test(pw)) sc++;
  if (/[^A-Za-z0-9]/.test(pw)) sc++;
  return LEVELS[Math.min(sc, 4)];
}

export default function PasswdModal({ id, onAudit }) {
  const { toast, closeModal } = useUI();
  const [user, setUser] = useState("Administrator");
  const [oldPassword, setOldPassword] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [admin, setAdmin] = useState("");
  const [busy, setBusy] = useState(false);

  const lvl = p1 ? strength(p1) : null;

  const confirm = async () => {
    if (!oldPassword) return toast("Nhập mật khẩu máy chủ cũ", "err");
    if (!p1 || p1.length < 8) return toast("Mật khẩu mới tối thiểu 8 ký tự", "err");
    if (p1 !== p2) return toast("Mật khẩu mới không khớp", "err");
    if (!admin) return toast("Nhập mật khẩu admin web", "err");
    if (busy) return;
    setBusy(true);
    toast(`Đang đổi mật khẩu ${id}...`, "info", 1500);
    try {
      const { ok, data } = await changeServerPassword(id, {
        user: user || "Administrator",
        oldPassword,
        newPassword: p1,
        adminPassword: admin,
      });
      if (!ok) {
        setBusy(false);
        return toast(data.message || "Đổi mật khẩu thất bại", "err");
      }
      closeModal();
      toast(`Đã đổi mật khẩu '${user}' · ${id}`, "ok");
      onAudit("PASSWD", id, "var(--purple)");
    } catch (err) {
      setBusy(false);
      toast("Không kết nối được BackendNode", "err");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <div style={{
        background: "var(--amber-soft)",
        border: "1px solid var(--amber)",
        borderRadius: "10px",
        padding: "12px 14px",
        color: "var(--amber)",
        fontSize: "13px",
        lineHeight: "1.5",
        marginBottom: "15px",
      }}>
        Thay đổi mật khẩu tài khoản Windows trên máy chủ <strong>{id}</strong>.
      </div>
      
      <div className="field-lbl">Tài khoản Windows</div>
      <input
        className="field-inp"
        type="text"
        value={user}
        onChange={(e) => setUser(e.target.value)}
      />
      
      <div className="field-lbl">Mật khẩu máy chủ cũ</div>
      <input
        className="field-inp"
        type="password"
        value={oldPassword}
        placeholder="Nhập mật khẩu máy chủ cũ"
        onChange={(e) => setOldPassword(e.target.value)}
      />
      
      <div className="field-lbl">Mật khẩu mới</div>
      <input
        className="field-inp"
        type="password"
        value={p1}
        placeholder="Nhập mật khẩu mới (tối thiểu 8 ký tự)"
        onChange={(e) => setP1(e.target.value)}
        style={{ marginBottom: "6px" }}
      />
      
      {/* Password strength bar */}
      <div style={{
        height: "5px",
        background: "var(--border)",
        borderRadius: "99px",
        overflow: "hidden",
        marginBottom: "6px",
      }}>
        <div style={{
          width: lvl ? lvl.w : "0%",
          background: lvl ? lvl.c : "var(--red)",
          height: "100%",
          transition: "width 0.3s ease, background 0.3s ease",
        }}></div>
      </div>
      <div style={{
        fontSize: "10px",
        fontFamily: "var(--font-mono)",
        color: lvl ? lvl.c : "var(--faint)",
        marginBottom: "15px",
      }}>
        {lvl ? lvl.t : "Chưa nhập"}
      </div>

      <div className="field-lbl">Xác nhận mật khẩu mới</div>
      <input
        className="field-inp"
        type="password"
        value={p2}
        placeholder="Nhập lại mật khẩu mới"
        onChange={(e) => setP2(e.target.value)}
      />
      
      <div className="field-lbl">Mật khẩu admin web</div>
      <input
        className="field-inp"
        type="password"
        value={admin}
        placeholder="Nhập mật khẩu tài khoản Admin Web"
        onChange={(e) => setAdmin(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && confirm()}
      />
      
      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal}>
          Huỷ
        </button>
        <button className="mbtn mbtn-primary" onClick={confirm} disabled={busy}>
          {busy ? "Đang gửi..." : "⚿ Đổi mật khẩu"}
        </button>
      </div>
    </div>
  );
}
